import Header from "@commons/header";
import Column from "@components/column";
import React, { useEffect, useState } from "react";
import ProductSetup from "./product-setup";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import Tab from "@components/tabs";
import Overview from "./overview";
import Orders from "./orders";
import Reviews from "./Reviews";
import Settings from "./settings";
import Disbursement from "./disbursement";
import Withdrawals from "@pages/store/withdrawals";
import BusinessPlan from "./business-plan";
import Discount from "./discounts";
import MetaData from "./metadata";
import StoreApi from "@apis/store";

import { Helper } from "@utils/index";
import BankDetails from "./bank-details";

const IndividualStore = () => {
  const { state } = useLocation();
  const { storeId: paramStoreId } = useParams();
  const user = Helper.getUser();

  // Use paramStoreId if available (Admin view), otherwise use logged-in user ID (Store view)
  const storeId = paramStoreId || (user?.role === "store" ? user?.id : null);

  const [searchParams] = useSearchParams();
  const [storeData, setStoreData] = useState<any>(state || null);
  const [loading, setLoading] = useState<boolean>(!state);

  useEffect(() => {
    // Only fetch if we don't have state and we have a storeId
    if (!state && storeId) {
      setLoading(true);
      StoreApi.find({ id: storeId })
        .then((res: any) => {
          // console.log("Full Store Response:", res);
          // Handle potential response wrappers depending on request utility
          if (res?.data) {
            setStoreData(res.data);
          } else {
            setStoreData(res);
          }
        })
        .catch((err) => {
          console.error("Error fetching individual store:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (state) {
      // If state exists, ensure loading is false
      setLoading(false);
      setStoreData(state);
    } else if (!storeId) {
      // Only stop loading if we truly have no ID to fetch (shouldn't happen for valid store logic)
      setLoading(false);
    }
  }, [state, storeId]);

  const dataToPass = storeData;

  const tabs: any = [
    { label: "Overview", component: Overview, props: { state: dataToPass } },
    { label: "Orders", component: Orders, props: { storeId: storeId } },
    {
      label: "Products",
      component: ProductSetup,
      props: { state: dataToPass },
    },
    { label: "Reviews", component: Reviews },
    { label: "Discounts", component: Discount, props: { state: dataToPass } },
    { label: "Metadata", component: MetaData },
    {
      label: "Transactions",
      component: Disbursement,
      props: { storeId: storeId },
    },
    { label: "Withdraw", component: Withdrawals, props: { storeId: storeId } },
    {
      label: "Business Plan",
      component: BusinessPlan,
      props: { state: dataToPass },
    },
    { label: "Settings", component: Settings, props: { state: dataToPass } },
    {
      label: "Payment Details",
      component: BankDetails,
      props: { storeId: storeId },
    },
  ];

  if (loading) {
    return (
      <Column>
        <Header title="Store Details" />
        <div style={{ padding: 20, textAlign: "center" }}>
          Loading store details...
        </div>
      </Column>
    );
  }

  return (
    <Column>
      <Tab items={tabs} />
    </Column>
  );
};

export default IndividualStore;
